import { useToast } from '@chakra-ui/toast';
import { useQuery } from 'react-query';
import { getFbAccounts } from '../../../api/firebase';

export default function useFacebookAccounts(enabled: boolean, teamId: string) {
  const toast = useToast();
  return useQuery('fbaccounts', () => getFbAccounts(teamId), {
    enabled,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    onError: (error: Error) => {
      toast({
        description: `${error}`,
        position: 'top-right',
        duration: 9000,
        status: 'error',
        isClosable: true,
      });
    },
  });
}
